<template>
  <div class="section-prize-sub-about-wrapper">

    <!-- background -->
    <div class="background" v-if="isDesktop">
      <img class="object" src="../assets/car.svg" />
    </div>

    <div class="section-prize-sub-about" :class="[{ 'is-alt': isAlt }]" data-aos="fade-up" data-aos-once="true">

      <!-- header -->
      <page-subheader :title="paragraph.title"></page-subheader>

      <div-container>
        <div-columns v-if="imageUrl">
          <div class="columns is-gapless is-centered is-flex-mobile is-vcentered">
            <div class="column is-5 has-text-centered">
              <img :src="imageUrl" width="200" style="width:100%;padding:30px;" />
            </div>
          </div>
        </div-columns>
        <div-columns paddingTop="1rem" :class="{ 'with-image': imageUrl !== undefined }" >
          <div v-html="paragraph.content" />
        </div-columns>
        <!-- <div class="control notification is-danger" v-if="error">
          <button class="delete" @click="error = undefined"></button>
          <p v-html="error">
          </p>
        </div> -->

      </div-container>
    </div>

    <div class="section-prize-sub-about" data-aos="fade-up" data-aos-once="true" v-if="!isDesktop" style="text-align:right;padding-top:0;">
      <img class="object" src="../assets/car.svg" style="width:400px;" />
    </div>

  </div>
</template>

<script>
import Site from '@/apis/Site'
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import PageSubheader from '@/components/PageSubheader'
import ShowDown from 'showdown'
import 'showdown-target-blank'

export default {
  name: 'section-prize-sub-about',
  props: ['name', 'is-alt'],
  components: {
    DivContainer,
    DivColumns,
    PageSubheader
  },
  data () {
    return {
      isDesktop: true,
      paragraph: {
        title: '',
        content: ''
      },
      imageUrl: undefined,
      error: undefined,
      loading: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    getItems: function (onComplete) {
      this.loading = true
      this.error = undefined
      this.imageUrl = undefined
      this.paragraph.content = ''
      this.paragraph.title = ''
      Site.aboutWithName(this.name)
      .then((data) => {
        this.loading = false
        // console.log(data)
        if (!data || !data.content) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        var converter = new ShowDown.Converter({ extension: ['targetblank'] })
        var html = converter.makeHtml(data.content)
        this.paragraph.content = html
        this.paragraph.title = data.title
        this.imageUrl = data.image ? data.image.path : undefined

        if (onComplete) {
          onComplete(data)
        }
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },

    refresh: function () {
      this.getItems((item) => {
        // this.item = item
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section about prize

.section-prize-sub-about-wrapper {
  position: relative;
  background-color: $color-orange;

  .background {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    overflow:hidden;
    padding-top: 3em;
    padding-bottom: 3em;

    .object {
      position: absolute;
      top: 320px;
      right: -80px;
      height: 30%;
      max-height: 200px;

      @media screen and (min-width: $tablet) {
        top: 340px;
        right: 0%;
        height: 40%;
        max-height: 300px;
      }

      @media screen and (min-width: $desktop) {
        top: 300px;
        right: 0%;
        height: 50%;
        max-height: 400px;
      }

      @media screen and (min-width: $fullhd) {
        top: 100px;
        right: 0%;
        height: 70%;
        max-height: 500px;
      }
    }
  }

  .section-prize-sub-about {
    &.is-alt {
      // background-color: $color-orange;
    }

    padding-top: 3rem;
    padding-bottom: 3rem;

    @import "../styles/markdown.scss";
  }
}

</style>



// WEBPACK FOOTER //
// AboutPrizeSubSection.vue?25662db6